<template>

    <div class="conteudo">
        <div class="col">
            <img src="../../../assets/img/logo_np.png" class="logo mt-3" title="Grupo Negócios Públicos">
        </div>
        <h2 class="formularios pt-4">Dados Cadastrais da Instituição Responsável pela Inscrição</h2>
        <p class="descritivo">Vamos lá! Primeiramente preencha os dados da instituição responsável pela inscrição</p>

        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" v-model="instituicao.tpInstituicao" name="J" id="J" value="J" @change="tpChange">
            <label class="form-check-label font-4" for="tela1">
                Pessoa Jurídica
            </label>
        </div>
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" v-model="instituicao.tpInstituicao" name="F" id="F" value="F" @change="tpChange">
            <label class="form-check-label font-4" for="tela2">
                Pessoa Física
            </label>
        </div>


        <div class="row">
            <div class="form-group col-sm-12 col-lg-4 pt-1" v-if="instituicao.tpInstituicao == 'J'">
                <label for="cnpj" class="pb-1 font-1">CNPJ *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <div class="input-group">
                    <input class="form-control informacao2" id="cnpj" v-model="instituicao.nrCpfCnpj" @blur="carregaInstituicao" v-maska="'##.###.###/####-##'">
                    <div class="card">
                        <span class="input-group-btn">
                            <button class="btn btn-default" type="button"><i class="fa fa-search" aria-hidden="true" v-on:click="carregaInstituicao"></i></button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-group col-sm-12 col-lg-12 pt-1" v-else-if="instituicao.tpInstituicao == 'F'">
                <label for="e-mail1" class="pb-1 font-1">E-mail *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <div class="input-group">
                    <input class="form-control informacao2" id="e-mail1" v-model="instituicao.dsEmail" @blur="carregaEmail">
                    <div class="card">
                        <span class="input-group-btn">
                            <button class="btn btn-default" type="button"><i class="fa fa-search" aria-hidden="true"></i></button>
                        </span>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 col-lg-4 form-group" v-if="instituicao.tpInstituicao == 'F'">
                <label for="cpf2" class="pb-1 pt-3 font-1">CPF *</label>
                <span class="labelValidacao field-validation-valid"></span>
                <input class="form-control valid informacao" type="text" id="cpf2" name="cpf2" v-maska="'###.###.###-##'" v-model="instituicao.nrCpfCnpj" :disabled="valida_input()">
            </div>

            <div class="form-group col-sm-12 col-lg-8">
                <label for="instituicao" class="pb-1 pt-2 font-1" v-if="instituicao.tpInstituicao == 'J'">Nome Instituição *</label>
                <label for="instituicao" class="pb-1 pt-2 font-1" v-else-if="instituicao.tpInstituicao == 'F'">Nome *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control informacao" type="text" id="instituicao" name="instituicao" v-model="instituicao.nmNome" :disabled="valida_input()">
            </div>
            <div class="col-sm-12 col-lg-6 form-group">
                <label for="telefone" class="pb-1 pt-3 font-1">Telefone</label>
                <span class="labelValidacao field-validation-valid"></span>
                <input class="form-control valid informacao" type="text" id="telefone" name="telefone" v-maska="'(##) ####-####'" v-model="instituicao.nrTelefone" :disabled="valida_input()">
            </div>
            <div class="col-sm-12 col-lg-6 form-group">
                <label for="celular" class="pb-1 pt-3 font-1">Celular</label>
                <span class="labelValidacao field-validation-valid"></span>
                <input class="form-control valid informacao" type="text" id="celular" name="celular" v-maska="'(##) #####-####'" v-model="instituicao.nrCelular" :disabled="valida_input()">
            </div>
            <div class="form-group col-sm-12 col-lg-3">
                <label for="cep" class="pb-1 pt-3 font-1">Cep *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <div class="input-group">
                    <input class="form-control informacao2" type="text" id="cep" v-maska="'#####-###'" @focusout="getCEP(instituicao.dsCep)" v-model="instituicao.dsCep" :disabled="valida_input()">
                    <div class="card">
                        <span class="input-group-btn">
                            <button class="btn btn-default" type="button"><i class="fa fa-search" aria-hidden="true"></i></button>
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-group col-sm-12 col-lg-9">
                <label for="endereço" class="pb-1 pt-3 font-1">Endereço * </label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control informacao" type="text" id="endereço" v-model="instituicao.dsEndereco" :disabled="valida_input()">
            </div>
            <div class="form-group col-lg-3">
                <label for="numero" class="pb-1 pt-3 font-1">Número *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control informacao" type="text" id="numero" v-model="instituicao.nrNumero" :disabled="valida_input()">
            </div>
            <div class="col-sm-12 col-lg-4 form-group">
                <label for="complemento" class="pb-1 pt-3 font-1">Complemento</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control informacao" type="text" id="complemento" v-model="instituicao.dsComplemento" :disabled="valida_input()">
            </div>
            <div class="col-sm-12 col-lg-5 form-group">
                <label for="bairro" class="pb-1 pt-3 font-1">Bairro *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control informacao" type="text" id="bairro" v-model="instituicao.nmBairro" :disabled="valida_input()">
            </div>
            <div class="col-sm-12 col-lg-8 form-group">
                <label for="cidade" class="pb-1 pt-3 font-1">Cidade *</label>
                <span class="field-validation-valid labelValidacao"></span>
                <input class="form-control informacao" type="text" id="cidade" v-model="instituicao.nmCidade" :disabled="valida_input()">
            </div>
            <div class="col-sm-12 col-lg-4 form-group">
                <label for="uf" class="pb-1 pt-3 font-1">UF *</label>
                <span class="field-validation-valid idacao"></span>
                <select class="form-control informacao form-select" id="uf" v-model="instituicao.nmUf" :disabled="valida_input()">
                    <option value="">Selecione</option>
                    <option value="AC">AC</option>
                    <option value="AL">AL</option>
                    <option value="AM">AM</option>
                    <option value="AP">AP</option>
                    <option value="BA">BA</option>
                    <option value="CE">CE</option>
                    <option value="DF">DF</option>
                    <option value="ES">ES</option>
                    <option value="GO">GO</option>
                    <option value="MA">MA</option>
                    <option value="MT">MT</option>
                    <option value="MS">MS</option>
                    <option value="MG">MG</option>
                    <option value="PA">PA</option>
                    <option value="PB">PB</option>
                    <option value="PR">PR</option>
                    <option value="PE">PE</option>
                    <option value="PI">PI</option>
                    <option value="RJ">RJ</option>
                    <option value="RN">RN</option>
                    <option value="RO">RO</option>
                    <option value="RS">RS</option>
                    <option value="RR">RR</option>
                    <option value="SC">SC</option>
                    <option value="SE">SE</option>
                    <option value="SP">SP</option>
                    <option value="TO">TO</option>
                </select>
            </div>
            <div class="col-lg-8 form-group">
                <label for="convenio" class="pt-3 pb-1 font-1">Convênio</label>
                <select class="form-control valid form-select informacao" id="convenio" v-model="instituicao.idConvenio" :disabled="valida_input()">
                    <option value="0">Nenhum</option>
                    <option value="1">Banco do Brasil</option>
                </select>
                <span class="labelValidacao field-validation-valid"></span>
            </div>
        </div>
    </div>

</template>

<script>

    import axios from "axios";
    import $ from "jquery";

    export default {
        name: "Etapa_1",
        components: {},
        props: {
            inscricao_value: {
                type: Object,
                required: true
            },
            instituicao_value: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                inscricao: { ...this.inscricao_value },
                instituicao: { ...this.instituicao_value }
            };
        },
        methods: {
            tpChange(event) {
                this.inscricao = {
                    qtdParticipantesOnline: 0,
                    idEvento: 0,
                    flMesmaPessoa: false,
                    idTipoInscricao: 0,
                    nmNomeResponsavel: '',
                    dsEmailResponsavel: '',
                    nrTelefoneResponsavel: '',
                    nrCelularResponsavel: '',
                    dtNascimentoResponsavel: null,
                    idDepartamentoResponsavel: null,
                    idFuncaoResponsavel: null,
                    nmNomeFinanceiro: '',
                    dsEmailFinanceiro: '',
                    nrTelefoneFinanceiro: '',
                    nrCelularFinanceiro: '',
                    dtNascimentoFinanceiro: null,
                    idDepartamentoFinanceiro: null,
                    idFuncaoFinanceiro: null,
                    qtdParticipantes: 0,
                    flSalaoPrincipal: '',
                    idConvenio: null
                };
                this.instituicao = {
                    tpInstituicao: event.target.value,
                    nrCpfCnpj: '',
                    dsEmail: '',
                    nmNome: '',
                    dsCep: '',
                    nrTelefone: '',
                    nrCelular: '',
                    nmCidade: '',
                    nmUf: '',
                    dsEndereco: '',
                    nrNumero: '',
                    nmBairro: '',
                    dsComplemento: '',
                    idConvenio: 0
                };
            },
            zera_infos() {
                this.inscricao = {
                    qtdParticipantesOnline: 0,
                    idEvento: 0,
                    flMesmaPessoa: false,
                    idTipoInscricao: 0,
                    nmNomeResponsavel: '',
                    dsEmailResponsavel: '',
                    nrTelefoneResponsavel: '',
                    nrCelularResponsavel: '',
                    dtNascimentoResponsavel: null,
                    idDepartamentoResponsavel: null,
                    idFuncaoResponsavel: null,
                    nmNomeFinanceiro: '',
                    dsEmailFinanceiro: '',
                    nrTelefoneFinanceiro: '',
                    nrCelularFinanceiro: '',
                    dtNascimentoFinanceiro: null,
                    idDepartamentoFinanceiro: null,
                    idFuncaoFinanceiro: null,
                    qtdParticipantes: 0,
                    flSalaoPrincipal: '',
                    idConvenio: null
                };
                this.instituicao = {
                    tpInstituicao: this.instituicao.tpInstituicao,
                    nrCpfCnpj: '',
                    dsEmail: '',
                    nmNome: '',
                    dsCep: '',
                    nrTelefone: '',
                    nrCelular: '',
                    nmCidade: '',
                    nmUf: '',
                    dsEndereco: '',
                    nrNumero: '',
                    nmBairro: '',
                    dsComplemento: '',
                    idConvenio: 0
                };
            },
            zera_infos2() {
                this.inscricao = {
                    qtdParticipantesOnline: 0,
                    idEvento: 0,
                    flMesmaPessoa: false,
                    idTipoInscricao: 0,
                    nmNomeResponsavel: '',
                    dsEmailResponsavel: '',
                    nrTelefoneResponsavel: '',
                    nrCelularResponsavel: '',
                    dtNascimentoResponsavel: null,
                    idDepartamentoResponsavel: null,
                    idFuncaoResponsavel: null,
                    nmNomeFinanceiro: '',
                    dsEmailFinanceiro: '',
                    nrTelefoneFinanceiro: '',
                    nrCelularFinanceiro: '',
                    dtNascimentoFinanceiro: null,
                    idDepartamentoFinanceiro: null,
                    idFuncaoFinanceiro: null,
                    qtdParticipantes: 0,
                    flSalaoPrincipal: '',
                    idConvenio: null
                };
                this.instituicao = {
                    tpInstituicao: this.instituicao.tpInstituicao,
                    nrCpfCnpj: '',
                    dsEmail: this.instituicao.dsEmail,
                    nmNome: '',
                    dsCep: '',
                    nrTelefone: '',
                    nrCelular: '',
                    nmCidade: '',
                    nmUf: '',
                    dsEndereco: '',
                    nrNumero: '',
                    nmBairro: '',
                    dsComplemento: '',
                    idConvenio: 0
                };
                $('#cpf2').focus();
            },
            carregaInstituicao() {
                let $this = this;

                if ($this.instituicao.nrCpfCnpj != '' && $this.instituicao.nrCpfCnpj != null) {

                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Instituicao/CarregaCnpjExterno?nrCnpj=' + $this.instituicao.nrCpfCnpj, {
                        headers: null,
                        params: ''
                    }).then(response => {
                        if (this.instituicao.tpInstituicao == 'J') {
                            if (response.data.data.nmRazaoSocial != '') {
                                $this.instituicao.nmNome = response.data.data.nmRazaoSocial;
                                $this.instituicao.nrTelefone = response.data.data.nrTelefone;
                                $this.instituicao.dsCep = response.data.data.nrCep;
                                $this.instituicao.dsEndereco = response.data.data.dsEndereco;                                
                                $this.instituicao.nmBairro = response.data.data.dsBairro;
                                $this.instituicao.nrNumero = response.data.data.nrNumero;
                                $this.instituicao.dsComplemento = response.data.data.dsComplemento;
                                $this.instituicao.nmCidade = response.data.data.nmCidade;
                                $this.instituicao.nmUf = response.data.data.dsUf;
                                $this.instituicao.dsEmail = response.data.data.dsEmail;
                            }
                            else {
                                $this.zera_infos();
                            }
                        }

                        $('#instituicao').focus();
                    }).catch(error => {
                        $this.zera_infos();
                    });
                } else {
                    $this.zera_infos();
                }

            },
            getCEP(value) {
                let $this = this;

                axios.get('https://viacep.com.br/ws/' + value + '/json/', {
                }).then(response => {
                    $this.instituicao = {
                        ...$this.instituicao,
                        dsCep: response.data.cep,
                        nmCidade: response.data.localidade,
                        nmUf: response.data.uf,
                        dsEndereco: response.data.logradouro,
                        nmBairro: response.data.bairro
                    };
                    $('#numero').focus();
                });
            },
            carregaEmail() {
                let $this = this;
                $this.zera_infos2();
            },
            valida_input() {
                if (this.instituicao.tpInstituicao == 'J') {
                    if (this.validaCNPJ(this.instituicao.nrCpfCnpj) == true) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else if (this.instituicao.tpInstituicao == 'F') {
                    if (this.validaEmail(this.instituicao.dsEmail) == true) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            },
            validaCNPJ(cnpj) {
                cnpj = cnpj.replace(/[^\d]+/g, '');

                if (cnpj.length !== 14) return false;

                if (/^(\d)\1+$/.test(cnpj)) return false;

                let tamanho = cnpj.length - 2;
                let numeros = cnpj.substring(0, tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;

                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                }

                let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(0))) return false;

                tamanho = tamanho + 1;
                numeros = cnpj.substring(0, tamanho);
                soma = 0;
                pos = tamanho - 7;

                for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                }

                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                return resultado === parseInt(digitos.charAt(1));
            },
            validaEmail(email) {
                const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                return re.test(email);
            },
        },
        mounted() { },
        watch: {
            inscricao: {
                handler(newValue) {
                    this.$emit('update:inscricao_value', { ...newValue });
                },
                deep: true
            },
            instituicao: {
                handler(newValue) {
                    this.$emit('update:instituicao_value', { ...newValue });
                },
                deep: true
            }
        },
    };

</script>


<style scoped lang="scss">

    .container-formulario {
        background-color: #f8f8f8;
        padding: 0;
    }

    .painel {
        margin-top: 15px;
        margin-left: 80px;
        margin-right: 50px;
    }

    @media(min-width:992px) {
        .painel {
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel {
            margin-left: 40px;
            width: 220px;
            margin-right: 10px;
        }
    }

    @media(min-width:1350px) {
        .painel {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }


    @media(max-width:519px) {
        .painel {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    .conteudo {
        padding-left: 30px;
        padding-right: 40px;
    }

    @media(min-width:992px) {
        .conteudo {
            padding-left: 10px;
            margin-left: 30px;
        }
    }

    @media(min-width:1800px) {
        .conteudo {
            padding-left: 0px;
            margin-left: 30px;
        }
    }

    .linha-1 {
        border: 1px solid #d3d3d3;
        background-color: #fff;
        margin-left: 2px;
        margin-right: 2px;
        min-height: calc(100vh);
        border-top: none;
        border-bottom: none;
    }

    @media (min-width: 430px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 32px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 550px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 52px;
            margin-right: 32px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: 100px;
            margin-right: 70px;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 992px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            margin-left: calc(10vw - 30px) !important;
            margin-right: calc(10vw - 30px) !important;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1200px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1400px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1500px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1600px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    @media (min-width: 1800px) {
        .linha-1 {
            border: 1px solid #d3d3d3;
            background-color: #fff;
            border-top: none;
            border-bottom: none;
        }
    }

    .row > * {
        flex-shrink: 1;
    }

    .titulo {
        font-size: 14px;
        color: #bd2344;
        font-weight: 700
    }

    .titulo2 {
        font-size: 21px;
        line-height: 26px;
        color: #7a7a7a;
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .texto-1 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
        margin-top: 5px;
    }

    .texto-2 {
        font-size: 15px;
        line-height: 20px;
        color: #7a7a7a;
    }

    .painel-2 {
        margin-top: 10px;
        margin-left: 80px;
        margin-right: 50px;
        padding: 16px;
        margin-bottom: 30px;
    }

    @media(min-width:992px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            width: 200px;
            margin-right: 10px;
        }
    }

    @media(min-width:1200px) {
        .painel-2 {
            margin-top: 30px;
            margin-left: 40px;
            margin-right: 10px;
            width: 220px;
        }
    }

    @media(min-width:1350px) {
        .painel-2 {
            margin-left: 40px;
            width: 250px;
            margin-right: 10px;
        }
    }

    @media(max-width:519px) {
        .painel-2 {
            margin-left: 50px;
            margin-right: 50px;
        }
    }

    .painel-3 {
        display: block;
    }

    .btn-pagination {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pagination {
            padding: 15px;
        }
    }

    .btn-pagination2 {
        padding: 15px;
        border: none;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .card-painel {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
    }

    @media(min-width:630px) {
        .card-painel {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel {
            visibility: hidden;
            margin: 0;
            height: 0;
        }
    }


    .card-painel2 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel2 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel2 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel2 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel2 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 300px;
            display: block;
        }
    }

    .card-painel3 {
        margin-left: 40px;
        width: 220px;
        margin-right: 10px;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 16px;
    }

    @media(min-width:630px) {
        .card-painel3 {
            margin-left: 60px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:700px) {
        .card-painel3 {
            margin-left: 70px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:800px) {
        .card-painel3 {
            margin-left: 100px;
            width: 220px;
            margin-right: 10px;
            margin-top: 30px;
        }
    }

    @media(min-width:992px) {
        .card-painel3 {
            visibility: hidden;
            margin: 0;
            padding: 0;
            height: 0;
            display: block;
        }
    }

    .active > .page-link,
    .page-link.active {
        margin-right: 15px !important;
        border-color: #ba2743 !important;
        color: #fff !important;
        background: #ba2743 !important;
        width: 37px !important;
        height: 39px !important;
        text-align: center !important;
        padding-top: 6px !important;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none !important;
        outline-style: none !important;
        z-index: 99 !important;
        margin-left: 10px !important;
        padding-bottom: 10px !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        font-size: 16px !important;
    }


    .formularios {
        font-size: 22px;
        color: #bd2344;
        border-bottom: 1px solid #d3d3d3;
        padding-bottom: 10px;
        display: block;
    }

    .dados-instituicao {
        font-size: 18px;
        color: #bd2344;
        font-weight: 500;
        border-bottom: 1px solid#ececec;
        padding-bottom: 13px;
    }

    .logo {
        height: 34px;
        margin-bottom: 0px;
        margin-left: 10px;
        margin-right: 10px;
        float: right;
    }

    @media(max-width:991px) {
        .logo {
            visibility: hidden;
            height: 0;
            width: 0;
        }
    }

    @media(min-width:992px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1200px) {
        .logo {
            height: 34px;
            margin-right: 30px;
            margin-left: 10px;
            float: right;
        }
    }

    @media(min-width:1400px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1537px) {
        .logo {
            margin-right: 34px;
            float: right;
            height: 34px;
        }
    }

    @media(min-width:1800px) {
        .logo {
            margin-right: 20px;
            float: right;
            height: 34px;
        }
    }

    .evento {
        margin-top: 30px;
        height: 80px;
        width: 150px;
        margin-bottom: 0px;
        margin-right: 20px;
        margin-left: 20px;
    }

    @media(min-width:330px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 40px;
        }
    }

    @media(min-width:430px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 60px;
        }
    }

    @media(min-width:530px) {
        .evento {
            margin-top: 30px;
            height: 180px;
            width: 250px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 100px;
        }
    }

    @media(min-width:630px) {
        .evento {
            margin-top: 30px;
            height: 200px;
            width: 300px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 70px;
        }
    }

    @media(min-width:700px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 20px;
            margin-left: 80px;
        }
    }

    @media(min-width:800px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 120px;
        }
    }

    @media(min-width:920px) {
        .evento {
            margin-top: 30px;
            height: 250px;
            width: 400px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 180px;
            margin-bottom: 0;
            align-self: center;
        }
    }

    @media(min-width:992px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 200px;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1200px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 220px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    @media(min-width:1350px) {
        .evento {
            margin-top: 30px;
            height: 160px;
            width: 250px !important;
            margin-bottom: 0px;
            margin-right: 10px;
            margin-left: 40px;
        }
    }

    .descritivo {
        color: #777;
    }

    .informacao {
        border-color: #bbbbbb;
        margin-right: 1px;
        font-size: 14px;
    }

    .informacao2 {
        border-color: #bbbbbb;
        font-size: 14px;
    }

    .btn-danger {
        background-color: #bd2344;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    .icon-inscricao {
        padding-right: 5px;
        font-size: 15px;
    }

    .btn-inscricao {
        background-color: #bd2344;
        color: #fff;
        font-size: 15px;
        font-weight: 400;
        padding: 3px 5px;
        border-radius: 0;
        border: 2px solid #ececec;
    }

    @media(min-width:992px) {
        .btn-inscricao {
            background-color: #bd2344;
            color: #fff;
            font-size: 15px;
            font-weight: 400;
            padding: 3px 5px;
            border-radius: 0;
            border: 2px solid #ececec;
        }
    }

    #salvar {
        color: #fff;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 15px;
        font-weight: 500;
        padding: 10px 20px;
        border-radius: 0;
        border: 2px solid #ececec;
        margin-right: 20px;
    }

    .btn-success {
        background-color: #158000;
        color: #fff;
        margin-top: 20px;
        font-size: 15px;
        padding: 10px 20px;
        font-weight: 500;
    }

    .footer {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
    }

    .footer-2 {
        border-top: 1px solid #ececec;
        margin-top: 30px;
        border-color: #ddd;
        background-color: #f5f5f5;
    }

    .linha-2 {
        margin-left: 0px;
        margin-right: 0px;
        margin-top: 0;
        padding: 10px;
        background-color: #f5f5f5;
        border-color: #ddd;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        display: block;
    }

    .font-1 {
        font-weight: 600;
        font-size: 14px;
        color: #4c4c4c;
    }

    .font-2 {
        font-weight: 600;
        font-size: 14px;
        color: #575757;
        padding-left: 10px;
    }

    .font-3 {
        font-size: 13px;
        margin-bottom: 10px;
        padding-left: 10px;
    }


    @media(min-width:992px) {
        .font-3 {
            font-size: 13px;
            margin-bottom: 3px;
            padding-left: 10px;
        }
    }

    .font-4 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-5 {
        font-weight: 700;
        font-size: 16px;
        color: #4c4c4c;
    }

    .font-6 {
        font-weight: 400;
        color: #707070;
    }

    .font-7 {
        font-weight: 400;
        font-size: 16px;
        color: #4c4c4c;
        margin-top: 20px;
    }

    .input-checkbox {
        margin-top: 23px;
    }

    .btn-secondary {
        background-color: #d8d8d8;
        color: #575757;
        margin-top: 20px;
        font-size: 15px;
        font-weight: 700;
        border: #bbbbbb;
        padding: 10px 20px;
        border-radius: 0;
    }

    .btn-secondary:hover {
        background-color: #d8d8d8;
        color: #575757;
    }

    .btn-link {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 37px;
        height: 39px;
        text-align: center;
        padding-top: 5px;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
        margin-right: 15px;
        padding-bottom: 10px;
        padding-left: 0;
        padding-right: 0;
        font-size: 16px;
    }

    .btn-link-4 {
        border: 2px solid #f5f5f5;
        background: #f5f5f5;
        width: 43px;
        height: 45px;
        text-align: center;
        padding: 5px 0;
        border-radius: 0 !important;
        box-shadow: inset 0px 0px 0px 3px #fff !important;
        text-decoration: none;
        outline-style: none;
        z-index: 99;
        color: #bbb;
        background: #f5f5f5;
    }

    .cardbody {
        padding: 0;
    }

    .btn-pgnt {
        margin-bottom: 0;
    }

    .btn-pgnt2 {
        margin-bottom: 0;
    }

    @media(min-width:992px) {
        .btn-pgnt2 {
            height: 0;
        }
    }

    .container-2 {
        margin-left: 0;
        margin-top: 0;
    }

    .quantidade-participantes {
        border-color: #7a7a7a;
        font-size: 40px;
        box-shadow: 1px solid !important;
        color: #555 !important;
        font-weight: 600;
    }

    @media(min-width:992px) {
        .quantidade-participantes {
            border-color: #a8a8a8;
            margin-left: 90px;
            font-size: 40px;
        }
    }


    .m-quantidade-participantes {
        padding-top: 60px;
        padding-bottom: 40px;
    }

    #q-participantes {
        color: #4c4c4c;
        font-size: 20px;
        padding-left: 10px;
        font-weight: 600;
    }

    @media(min-width:992px) {
        #q-participantes {
            color: #4c4c4c;
            font-size: 20px;
            padding-left: 15px;
            font-weight: 600;
            margin-left: 95px;
        }
    }

    .paragrafo-1 {
        font-size: 16px;
        color: #96102d;
        padding-right: 40px;
        padding-left: 45px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-1 {
            font-size: 16px;
            padding-left: 0;
            padding-right: 0;
            margin-bottom: 0;
        }
    }

    .paragrafo-2 {
        font-size: 16px;
        color: #96102d;
        padding-left: 45px;
        padding-right: 40px;
        font-weight: 400;
    }

    @media(min-width:992px) {
        .paragrafo-2 {
            font-size: 16px;
            padding-right: 0;
            padding-left: 0;
        }
    }

    .corpo-col {
        padding-right: 0;
        margin-left: 10px;
    }

    @media(min-width:992px) {
        .corpo-col {
            margin-left: 130px;
            padding-right: 40px;
        }
    }

    .paragrafo-danger {
        font-size: 26px;
        text-align: center;
        color: #333;
        font-weight: 500;
    }
</style>